/**
 * Created by Carsten Bühler ##Test
 * User: CBuehler on 29.01.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { FormControl } from 'external/react-bootstrap';

class NumberSelect extends React.Component {

  constructor(props) {
    super(props);
    this.onItemChange = this.onItemChange.bind(this);
  }

  onItemChange(e) {
    if (this.props.multiple) {
      let data = [];

      for (let i = 0 ; i < e.target.options.length ; i++) {
        if (e.target.options[i].selected) {
          data.push(parseInt(e.target.options[i].value));
        }
      }
      this.props.onChange(data);

    } else {
      this.props.onChange(parseInt(e.target.value));
    }
  }

  render() {
    const {
      className, list, currentValue, currentKeys = [], defaultOption = (
        <option key={'option_-1'} value={-1}>{'Bitte wählen!'}</option>), multiple = false
    } = this.props;
    let selectedElement = this.props.multiple ? [] : -1;
    let options = defaultOption ? [ defaultOption ] : [];
    let createOption = (item, selected) => {
      if (selected) {
        options.push(<option key={'option_' + item.label + '_' + item.value}
                             value={item.value}>{item.label}</option>);
        this.props.multiple ? selectedElement.push(item.value) : selectedElement = item.value;
      } else {
        options.push(<option key={'option_' + item.label + '_' + item.value}
                             value={item.value}>{item.label}</option>);
      }
    };

    if (list && list.length > 0) {
      list.forEach(item => {
        if (multiple) {
          let contained = [];
          contained = currentKeys && currentKeys.filter(k =>
            k === item.value
          );
          let found = contained.length > 0;
          createOption(item, found);
        } else {
          createOption(item, currentValue === item.value);
        }
      });
    } else {
      return <span>---</span>;
    }

    return (
      <FormControl
        as="select"
        multiple={multiple}
        value={selectedElement}
        className={className}
        onChange={this.onItemChange}>
        {options}
      </FormControl>
    );
  }
}

NumberSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  list: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  defaultOption: PropTypes.object,
  currentValue: PropTypes.number,
  currentKeys: PropTypes.array,
  className: PropTypes.string,
};

export default NumberSelect;



// WEBPACK FOOTER //
// ./js/components/NumberSelect.jsx